<template>
  <div tabindex="0" class="font-inter">
    <router-view />
  </div>
</template>

<style lang="scss">
// TODO: Remove this once we have updated all font awesome icons to lucide
@use '@/styling/setup.scss';
@use '@/styling/peach.css';
@use '@/styling/tel-input.scss';
@use '@/styling/otp-input.scss';
@use '@/styling/layup-spinner.css';
</style>
